module.exports = __webpack_public_path__ + "static/media/Asesoria_CF_Etario_60_anos.016a922e.mp3";